theme.alinga = theme.alinga || {};

theme.alinga.footerMenuAccordian = () => {
  if(window.innerWidth <= 767){
    const accordionBtns = document.querySelectorAll(".menu-collapse-title");

    accordionBtns.forEach((accordion) => {
      accordion.onclick = function () {
        this.classList.toggle("is-open");

        let content = this.nextElementSibling;
        console.log(content);

        if (content.style.maxHeight) {
          content.style.maxHeight = null;
          console.log(content.scrollHeight);
        } else {
          content.style.maxHeight = content.scrollHeight + "px";
          console.log(content.style.maxHeight);
        }
      };
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  theme.alinga.footerMenuAccordian();
});